import { render, staticRenderFns } from "./UserSelectBox.vue?vue&type=template&id=aa570f02&"
import script from "./UserSelectBox.vue?vue&type=script&lang=js&"
export * from "./UserSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports